import { BarChartIcon } from 'src/assets/icons/nav/barchart.icon'
import { DoorManIcon } from 'src/assets/icons/nav/door-man.icon'
import { ShoppingBagIcon } from 'src/assets/icons/nav/shopping-bag.icon'
import { BedIcon } from 'src/assets/icons/sales/banner'
import { HousiDecorIcon } from 'src/components/navbar/icons/housidecor.icon'
import { PeopleIcon } from 'src/components/navbar/icons/people.icon'

export interface NavbarConfigItem {
  id: string
  title: string
  path?: string
  options?: OptionsNavbarInterface[]
}

interface OptionsNavbarInterface {
  id: string
  label: string
  path: string
  Icon: (props: any) => JSX.Element
}

export function NavbarItemsConfig() {
  const navbarItemsData: NavbarConfigItem[] = [
    {
      id: 'support',
      title: 'Fale conosco',
      options: [
        {
          id: 'talk-to-us',
          label: 'Equipe de reservas',
          path: 'https://api.whatsapp.com/send/?phone=5511949454798&text=Estava%20visitando%20o%20site%20e%20preciso%20de%20apoio!%20Consegue%20me%20ajudar?%20',
          Icon: BedIcon,
        },
        {
          id: 'housi-decor',
          label: 'Housi Decor',
          path: 'https://api.whatsapp.com/send/?phone=5511964123964&text=Estava%20visitando%20o%20site%20e%20preciso%20de%20apoio!%20Consegue%20me%20ajudar?%20',
          Icon: HousiDecorIcon,
        },
        {
          id: 'housi-sales',
          label: 'Invista com o Housi Vendas',
          path: 'https://api.whatsapp.com/send/?phone=5511972993281&text=Estava%20visitando%20o%20site%20e%20preciso%20de%20apoio!%20Consegue%20me%20ajudar?%20',
          Icon: BarChartIcon,
        },
        {
          id: 'parceiro-housi',
          label: 'Incorporador',
          path: 'https://api.whatsapp.com/send/?phone=5511956514966&text=Estava%20visitando%20o%20site%20e%20preciso%20de%20apoio!%20Consegue%20me%20ajudar?%20',
          Icon: ShoppingBagIcon,
        },
        {
          id: 'housi-gestao',
          label: 'Relacionamento com o investidor',
          path: 'https://api.whatsapp.com/send/?phone=5511937181210&text=Estava%20visitando%20o%20site%20e%20preciso%20de%20apoio!%20Consegue%20me%20ajudar?%20',
          Icon: PeopleIcon,
        },
        {
          id: 'housi-atendimento',
          label: 'Atendimento ao hóspede',
          path: 'https://api.whatsapp.com/send/?phone=5511916678278&text=Estava+visitando+o+site+e+preciso+de+apoio!+Consegue+me+ajudar%3F',
          Icon: DoorManIcon,
        },
      ],
    },
    {
      id: 'who-we-are',
      title: 'Quem somos',
      path: 'https://lps.housi.com/quemsomos',
    },
    {
      id: 'housi-blog',
      title: 'Blog Housi',
      path: 'https://housi.com/blog',
    },
  ]
  return { navbarItemsData }
}
